var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalToday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_2396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.35714 0C6.02879 0 6.57143 0.558594 6.57143 1.25V2.5H11.4286V1.25C11.4286 0.558594 11.9712 0 12.6429 0C13.3145 0 13.8571 0.558594 13.8571 1.25V2.5H15.6786C16.6842 2.5 17.5 3.33984 17.5 4.375V6.25H0.5V4.375C0.5 3.33984 1.31585 2.5 2.32143 2.5H4.14286V1.25C4.14286 0.558594 4.68549 0 5.35714 0ZM0.5 7.5H17.5V18.125C17.5 19.1602 16.6842 20 15.6786 20H2.32143C1.31585 20 0.5 19.1602 0.5 18.125V7.5ZM3.53571 10C3.20179 10 2.92857 10.2812 2.92857 10.625V14.375C2.92857 14.7188 3.20179 15 3.53571 15H7.17857C7.5125 15 7.78571 14.7188 7.78571 14.375V10.625C7.78571 10.2812 7.5125 10 7.17857 10H3.53571Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_2396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalToday);
export default __webpack_public_path__ + "static/media/icon-cal-today.b183a0ac30c17ebe73297bb97d2b8f4f.svg";
export { ForwardRef as ReactComponent };